import React, { useEffect, useState } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function Pendingdeo() {
  const [pendingData, setPendingData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPendingData = async () => {
      try {
        const token = sessionStorage.getItem("tokenclassix");

        const response = await fetch(
          `${config.API_BASE_URL}/FetchPrincipalDEOPendingSchools_CL9`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);
        if (response.ok) {
          setPendingData(result.data.principalDEOPending_status || []);
        } else {
          console.error("API Error:", result.message);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Fetch error:", error);
      }
    };

    fetchPendingData();
  }, []);

  const filteredStudents = pendingData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.gender?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.toLowerCase().includes(query) ||
      student.checklisT_STATUS?.toLowerCase().includes(query) ||
      student.prinT_CATEGORY?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div className="container-scroller">
      <Navbar />
      {isLoading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                <i className="fa fa-user"></i>&nbsp; Pending at DEO
              </h1>
              <ol className="breadcrumb">
                <li>
                  <a href="#" onClick={() => navigate("/class-ix-dashboard")}>
                    <i className="fa fa-home"></i> Home&nbsp;
                  </a>
                </li>
                <li className="active">Pending at DEO</li>
              </ol>
            </section>

            <div className="card mt-4">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center">
                    <label htmlFor="rowsPerPage" className="me-2 mb-0">
                      Rows:
                    </label>
                    <div style={{ width: "250px" }}>
                      <select
                        id="rowsPerPage"
                        className="form-select form-select-sm"
                        value={perPage}
                        onChange={handlePerPageChange}
                        style={{
                          width: "80px", // or adjust as needed (80–120px)
                          paddingRight: "2rem", // ensures space for the dropdown arrow
                        }}
                      >
                        {[10, 20, 50, 100, 500].map((num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div style={{ width: "200px" }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                {isLoading ? (
                  <p>Loading...</p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead className="table-primary">
                        <tr>
                          <th>Sl No.</th>
                          <th>Checklist Status</th>
                          <th>Category</th>
                          <th>DEO Status</th>
                          <th>Candidate Name</th>
                          <th>Gender</th>
                          <th style={{ width: "110px" }}>DOB</th>
                          <th>Father's Name</th>
                          <th>Mother's Name</th>
                          <th>Aadhaar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No data found.
                            </td>
                          </tr>
                        ) : (
                          currentItems.map((row, index) => (
                            <tr key={index}>
                              <td>{(currentPage - 1) * perPage + index + 1}</td>
                              <td>
                                {" "}
                                <span className="badge badge-warning">
                                  <i className="fa fa-clock"></i>&nbsp;
                                  {row.checklisT_STATUS || ""}
                                </span>
                              </td>
                              <td>
                                {" "}
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "red",
                                    fontSize: "12px",
                                  }}
                                >
                                  {row.prinT_CATEGORY}
                                </span>
                              </td>
                              <td>
                                {" "}
                                <span className="badge badge-warning">
                                  <i className="fa fa-clock"></i>&nbsp;
                                  {row.deO_STATUS || ""}
                                </span>
                              </td>
                              <td>{row.candidatE_NAME || ""}</td>
                              <td>{row.gender}</td>
                              <td>{row.dob}</td>
                              <td>{row.fatheR_NAME}</td>
                              <td>{row.motheR_NAME}</td>
                              <td>{row.aadhaR_CARD}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {(currentPage - 1) * perPage + 1} to{" "}
                    {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                    {filteredStudents.length} entries
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <MdOutlineKeyboardDoubleArrowLeft
                      onClick={() => {
                        if (currentPage > 1) setCurrentPage(1);
                      }}
                      style={{
                        cursor: currentPage > 1 ? "pointer" : "not-allowed",
                        opacity: currentPage > 1 ? 1 : 0.5,
                      }}
                    />

                    <MdOutlineKeyboardArrowLeft
                      onClick={() => {
                        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
                      }}
                      style={{
                        cursor: currentPage > 1 ? "pointer" : "not-allowed",
                        opacity: currentPage > 1 ? 1 : 0.5,
                      }}
                    />

                    <span>
                      Page {currentPage} of {totalPages}
                    </span>

                    <MdOutlineKeyboardArrowRight
                      onClick={() => {
                        if (currentPage < totalPages)
                          setCurrentPage((prev) => prev + 1);
                      }}
                      style={{
                        cursor:
                          currentPage < totalPages ? "pointer" : "not-allowed",
                        opacity: currentPage < totalPages ? 1 : 0.5,
                      }}
                    />

                    <MdOutlineKeyboardDoubleArrowRight
                      onClick={() => {
                        if (currentPage < totalPages)
                          setCurrentPage(totalPages);
                      }}
                      style={{
                        cursor:
                          currentPage < totalPages ? "pointer" : "not-allowed",
                        opacity: currentPage < totalPages ? 1 : 0.5,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Pendingdeo;
